module.exports = __webpack_public_path__ + "static/oblakoder-home-3-94e04eefe3e28fcc12a306f71a0ea326.png";